import {UNIT_TYPES, UNITS_SAME_TIME_COUNT_LIMIT} from '../../../configs/units';
import {FACTIONS} from '../../../constants/factions';
import {RATMEN_D6_SAME_TYPE_UNIT_LIMIT} from '../../../configs/factions/ratmen';
import {GIANTS_D20_SAME_TYPE_UNIT_LIMIT} from '../../../configs/factions/giants';
import {isPlayerFaction} from "../../factions/isPlayerFaction";

export function getSameTypeUnitLimit(player, unitTypeId) {
  if (isPlayerFaction(player, FACTIONS.RATMEN) && unitTypeId === UNIT_TYPES.D6.id) {
    return RATMEN_D6_SAME_TYPE_UNIT_LIMIT;
  }

  if (isPlayerFaction(player, FACTIONS.GIANTS) && unitTypeId === UNIT_TYPES.D20.id) {
    return GIANTS_D20_SAME_TYPE_UNIT_LIMIT;
  }

  return UNITS_SAME_TIME_COUNT_LIMIT;
}

export function checkSameTypeUnitRecruitmentLimit(currentPlayer, selectedToken, playerUnits) {
  const playerUnitsOfType = playerUnits.filter(u => u.type === selectedToken);
  const limit = getSameTypeUnitLimit(currentPlayer, selectedToken);
  return playerUnitsOfType.length < limit;
}
